<template>
    <!-- 新增/匯款紀錄 -->
    <el-dialog :title="dialogTitle" width="500px" v-model="dialogFormVisible" @open="onDialogOpen" center
               label-width="" :lock-scroll="false" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="formRef" :inline-message="true" label-position="top" :disabled="IDdisabled">
            <el-row :gutter="6">
                <el-col :span="12">
                    <el-form-item label="交易日期" prop="TRADE_DATE">
                        <el-date-picker v-model="form.TRADE_DATE" type="date" placeholder="請選擇" format="YYYY/MM/DD" value-format="YYYY-MM-DD" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="時間" prop="TRADE_TIME">
                        <el-time-picker v-model="form.TRADE_TIME" placeholder="請選擇" format="HH:mm:ss" value-format="HH:mm:ss" default-value="0" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="6">
                <el-col>
                    <el-form-item label="付款方式" prop="PAY_TYPE">
                        <el-select v-model="form.PAY_TYPE" placeholder="請選擇" style="width: 100%;">
                            <el-option label="Direct Pay" value="Direct Pay"></el-option>
                            <el-option label="Apple Pay" value="Apple Pay"></el-option>
                            <el-option label="Google Pay" value="Google Pay"></el-option>
                            <el-option label="LINE Pay" value="LINE Pay"></el-option>
                            <el-option label="Samsung Pay" value="Samsung Pay"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="6">
                <el-col>
                    <el-form-item label="交易金額" prop="PAY_AMT">
                        <el-col :span="4" style="padding: 0;">
                            <el-input v-model="form.CURR" disabled></el-input>
                        </el-col>
                        <el-col :span="20" style="padding: 0;">
                            <el-input v-model="form.PAY_AMT" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" :parser="(value) => value.replace(',', '')"></el-input>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="6">
                <el-col>
                    <el-form-item label="交易識別碼" prop="TRADE_NO">
                        <el-input v-model="form.TRADE_NO"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="6">
                <el-col>
                    <el-form-item prop="REMARKS">
                        <el-row type="flex" align="middle" justify="space-between" style="width: 100%;">
                            <el-text class="mx-1">備註說明</el-text>
                            <el-button @click="onBankClick" size="small">匯款銀行</el-button>
                        </el-row>
                        <el-input id="form_REMARKS" type="textarea" v-model="form.REMARKS" :rows="4"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-show="IDdisabled">
                <el-col :span="5" style="padding: 0 6px;">
                    <el-text class="mx-1">建檔/修改人:</el-text>
                </el-col>
                <el-col :span="19" style="padding: 0 6px;">
                    <el-text class="mx-1">{{ form.CREATE_USER }}</el-text>
                </el-col>
            </el-row>
            <el-row v-show="IDdisabled">
                <el-col :span="19" :offset="5" style="padding: 0 6px;">
                    <el-text class="mx-1">{{ form.CREATE_TIME }}</el-text>
                </el-col>
            </el-row>
        </el-form>
        <template #footer class="dialog-footer">
            <el-button type="info" @click="dialogFormVisible = false" style="width: 150px;">取消</el-button>
            <el-button type="primary" @click="onSubmit" style="width: 150px;" v-show="!IDdisabled">存檔</el-button>
        </template>
    </el-dialog>
</template>

<script lang="js">
    import { defineComponent, defineEmits, ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios';

    export default defineComponent({
        props: ["msg", "VENDORID"],
        data() {
            return {
                dialogFormVisible: false, //顯示dialog
                dialogTitle: '', //dialog標題
                addOrEdit: '',
                IDdisabled: false, //編輯時ID狀態
                formData: null,
                form: {
                    PAY_SEQ: '',
                    OUTLET_SEQ: '',
                    VENDOR_ID: '',
                    PAY_TYPE: '',
                    PAY_AMT: '',
                    CURR: 'TWD',
                    TRADE_DATE: '',
                    TRADE_TIME: '',
                    TRADE_NO: '',
                    TRADE_STATE: '',
                    REMARKS: '',
                    CREATE_USER: '',
                    CREATE_TIME: ''
                },
                rules: {
                    TRADE_DATE: [{ required: true, message: '請選擇交易日期', trigger: 'blur' }],
                    TRADE_TIME: [{ required: true, message: '請選擇時間', trigger: 'blur' }],
                    PAY_TYPE: [{ required: true, message: '請選擇付款方式', trigger: 'blur' }],
                    PAY_AMT: [{ required: true, message: '請輸入交易金額', trigger: 'blur' }],
                }
            };
        },
        methods: {
            onDialogOpen() {
                this.$nextTick(() => {
                    if (this.addOrEdit == 'add') {
                        this.$refs['formRef'].resetFields();
                    } else {
                        this.form = this.formData;
                    }
                });
            },
            onBankClick() { // 匯款銀行按鈕
                const info = "銀行:\n帳號:\n方式:\n";
                var remarks = document.getElementById('form_REMARKS');
                if (remarks.value == '') remarks.value = info;
                else remarks.value = remarks.value + "\n" + info;
            },
            onAddClick() {
                this.addOrEdit = 'add';
                this.dialogTitle = '[新增]';
                this.IDdisabled = false;
                this.dialogFormVisible = true;
            },
            onEditClick(data) {
                this.addOrEdit = 'edit';
                this.dialogTitle = '[匯款紀錄]';
                this.IDdisabled = true;
                this.formData = data;
                this.dialogFormVisible = true;
            },
            onSubmit() {
                this.$refs['formRef'].validate((valid) => {
                    if (valid) {
                        this.form.VENDOR_ID = this.$props.VENDORID;
                        this.form.TRADE_TIME = this.form.TRADE_DATE + ' ' + this.form.TRADE_TIME;
                        this.form.PAY_AMT = this.form.PAY_AMT.replace(',', '');
                        $api.POST('/api/OutletPay/Add', {
                            form: this.form, URL_ADDR: this.$props.msg
                        }).then((res) => {
                            if (res > 0) {
                                ElMessageBox.alert('新增成功!', '提示', {
                                    confirmButtonText: '確定',
                                    callback: action => {
                                        this.$refs['formRef'].resetFields();
                                        this.dialogFormVisible = false;
                                        this.$emit('reload'); // 呼叫父重整table
                                    }
                                });
                            } else {
                                ElMessageBox.alert('新增失敗!', '提示', {
                                    confirmButtonText: '確定'
                                });
                            }
                        })
                    }
                });
            },
        },
        mounted() {
        }
    });
</script>